// Move existing nodes, never clone headings or product forms. Restore desktop order.
(() => {
  if (window.sdMobileProductLayoutLoaded) return;
  window.sdMobileProductLayoutLoaded = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const states = new WeakMap();
  function initialise(root) {
    const previous = states.get(root);
    const details = root.querySelector('.product-details');
    const information = root.querySelector('.sd-left-content');
    const service = root.querySelector('.sd-mobile-service-line');
    const purchase = root.querySelector('.buy-buttons-block');
    if (previous && previous.details === details && previous.information === information && previous.service === service && previous.purchase === purchase && previous.entries.every(({ anchor }) => anchor.isConnected)) return;
    const entries = [];
    function remember(node) {
      if (!node) return null;
      let anchor = previous?.entries.find((entry) => entry.node === node && entry.anchor.isConnected)?.anchor;
      if (!anchor) {
        anchor = document.createComment('SHOEDEAL desktop position');
        const media = root.querySelector('.product-information__media');
        if (node === information && media && node.parentElement !== media) media.append(anchor);
        else node.before(anchor);
      }
      entries.push({ node, anchor });
      return node;
    }
    remember(information);
    if (service && purchase && service.parentElement === purchase.parentElement) remember(purchase);
    const seen = new Set();
    const duplicateRows = [];
    information?.querySelectorAll('.sd-left-accordion details').forEach((row) => {
      const signature = row.textContent.replace(/\s+/g, ' ').trim();
      if (seen.has(signature)) {
        const wrapper = row.closest('accordion-custom') || row;
        duplicateRows.push({ wrapper, hidden: wrapper.hidden });
      } else seen.add(signature);
    });
    states.set(root, { details, information, service, purchase, entries, duplicateRows });
  }
  function enhanceVariantPickers(root) {
    root.querySelectorAll('variant-picker fieldset.variant-option--buttons').forEach((fieldset, index) => {
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return;
      let select = fieldset.querySelector('.sd-mobile-variant-select');
      if (!select) {
        select = document.createElement('select');
        select.className = 'sd-mobile-variant-select';
        const legend = fieldset.querySelector('legend');
        select.setAttribute('aria-label', legend?.textContent.trim() || radios[0].name);
        radios.forEach((radio) => {
          const option = document.createElement('option');
          option.value = radio.value;
          // Reuse the visible option text. Native variant logic owns availability.
          option.textContent = radio.value;
          select.append(option);
        });
        select.addEventListener('change', (event) => {
          // Do not let the proxy be mistaken for a native variant input.
          event.stopPropagation();
          const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === select.value);
          if (radio && !radio.disabled && !radio.checked) radio.click();
        });
        fieldset.append(select);
        fieldset.classList.add('sd-mobile-dropdown-ready');
      }
      const checked = radios.find((radio) => radio.checked);
      if (checked) select.value = checked.value;
      Array.from(select.options).forEach((option) => {
        const radio = radios.find((input) => input.value === option.value);
        option.disabled = Boolean(radio?.disabled);
        const unavailable = radio?.dataset.optionAvailable === 'false' || radio?.getAttribute('aria-disabled') === 'true' || Boolean(radio?.disabled);
        const label = unavailable ? `${option.value} – ${root.dataset.sdSoldOutLabel}` : option.value;
        if (option.textContent !== label) option.textContent = label;
      });
    });
  }
  let scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }
  const observedRoots = new WeakSet();
  function update() {
    document.querySelectorAll('.sd-product-layout').forEach((root) => {
      enhanceVariantPickers(root);
      if (!observedRoots.has(root)) {
        observedRoots.add(root);
        new MutationObserver(scheduleUpdate).observe(root, { childList: true, subtree: true });
      }
      initialise(root);
      const state = states.get(root);
      state.duplicateRows.forEach(({ wrapper, hidden }) => {
        wrapper.hidden = mobile.matches ? true : hidden;
      });
      if (mobile.matches) {
        if (state.details && state.information && state.details.nextElementSibling !== state.information) state.details.after(state.information);
        if (state.service && state.entries.some(({ node }) => node === state.purchase) && state.purchase.nextElementSibling !== state.service) state.service.before(state.purchase);
      } else {
        state.entries.forEach(({ node, anchor }) => {
          if (anchor.isConnected && anchor.nextSibling !== node) anchor.after(node);
        });
      }
    });
    document.dispatchEvent(new Event('sd:mobile-layout-ready'));
  }
  function start() {
    update();
    // Also discover a replacement main section (e.g. connected-product navigation).
    new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) => node instanceof Element && (node.matches('.sd-product-layout') || node.querySelector('.sd-product-layout'))))) scheduleUpdate();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  mobile.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
})();
